import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    CShttp: "",
    useId: '',
    loading: false,
    showMsg: false,
    showMsgUrl: '',
    log: '',
    lat: '',
    wxJSSDK: '',
    ZChttp: '',
    SearchValue: '',
    showShareCoupon:false
  },
  mutations: {
    // 用户注册页面
    ZChttp(state, show) {
      state.ZChttp = show
    },
    // 服务器地址
    CShttp(state, show) {
      state.CShttp = show
    },
    // 用户注册后ID等信息
    UserSelf(state, show) {
      state.useId = show ? show.id : 15
      state.UserSelf = show
    },
    // 用户注册后ID等信息
    wxJSSDK(state, show) {
      state.wxJSSDK = show
    },
    showLoading(state, show) {
      state.loading = show
    },
    showMsg(state, date) {
      state.showMsg = date.show
      state.showMsgUrl = date.type
      state.showMsgText = date.msg
    },
    location(state, date) {
      state.log = date ? date.log : '120.21201'
      state.lat = date ? date.lat : '30.2084'
    },
    //用户openid等信息
    UserInfo(state, date) {
      state.UserInfo = date.UserInfo
    },

    SearchValue(state, date) {
      state.SearchValue = date.SearchValue
    },
    showShareCoupon(state, date) {
      state.showShareCoupon =date
    },
  },
  actions: {},
  modules: {

  }
})